import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const AtSign = (props: SvgProps) => (
  <Svg viewBox='0 0 13 13' {...props}>
    <Path
      fill='currentColor'
      d='M9.646 10.742c-.896.546-2.058.742-3.262.742-2.702 0-4.312-1.736-4.312-4.34.014-3.094 2.03-5.586 5.124-5.586 2.52 0 4.214 1.4 4.214 3.808 0 1.89-.994 3.304-2.142 3.304-.546 0-.658-.35-.406-1.414L9.8 3.504H8.736l-.238.952c-.126-.476-.56-1.092-1.666-1.092-1.722 0-3.066 1.918-3.066 3.976 0 1.498.77 2.24 1.904 2.24.924 0 1.554-.364 2.058-1.064.028.756.518 1.078 1.316 1.078 1.876 0 3.388-1.736 3.388-4.284 0-3.066-2.38-4.662-5.152-4.662-3.752 0-6.3 2.996-6.3 6.496 0 3.346 2.198 5.306 5.334 5.306 1.68 0 2.884-.392 3.57-.868l-.238-.84ZM6.93 4.274c1.064 0 1.4.756 1.022 2.24-.35 1.442-1.078 2.142-1.96 2.142-.714 0-1.064-.49-1.064-1.414 0-1.4.784-2.968 2.002-2.968Z'
    />
  </Svg>
)
